<template>
    <div class="p-care__period">
        <control :no-flex-margin="true" :label="'Period '+ Number(index+1)">
            <div class="a-form-inputs--half">
                <div class="a-form-inputs__container">
                    <date-input v-model="period.periodStart"
                                name="periodStart"
                                ref="periodStart"
                                v-field-control:periodStart.required="{type:'date'}"
                                @input="updateTotal()"></date-input>
                    <div class="a-checkbox u-margin-tb-10-30">
                        <input autocomplete="off" type="checkbox" v-model="period.includeFirstDay"
                               @change="updateTotal">
                        <label>Include first day</label>
                    </div>
                    <control-error :show="!periodStartDateRules">
                        The Period Start Date is required and must be in the format DD/MM/YYYY
                        and can not be after the Period End Date
                    </control-error>
                </div>
                <div class="a-form-inputs__container">
                    <date-input v-model="period.periodEnd"
                                name="periodEnd"
                                ref="periodEnd"
                                v-field-control:periodEnd.required="{type:'date'}"
                                @input="updateTotal"></date-input>
                    <div class="a-checkbox u-margin-tb-10-30">
                        <input autocomplete="off" type="checkbox" v-model="period.includeLastDay"
                               @change="updateTotal">
                        <label>Include last day</label>
                    </div>
                    <control-error :show="!periodEndDateRules">
                        The Period End Date is required and must be in the format DD/MM/YYYY
                        and can not be before the Period Start Date
                    </control-error>
                </div>
            </div>

            <control-error :show="overlapsAnother">
                This period overlaps another.
            </control-error>
        </control>

        <control label="Hours per Day">
            <select name="hours_per_day"
                    v-field-control
                    v-model="period.hoursPerDay"
                    @change="updateTotal()">
                <option v-for="hour in 24"
                        :value="hour">
                    {{ hour }}
                </option>
            </select>
        </control>

        <control label="Rate">
            <select ref="rates" id="method1"
                    v-model="period.rate"
                    required
                    @change="updateTotal()">
                <option value="" disabled hidden>Please select...</option>
                <option value="basic">Basic Rate</option>
                <option value="aggregate">Aggregate</option>
            </select>
            <div class="a-checkbox u-margin-top-10">
                <input autocomplete="off" type="checkbox" v-model="period.gratuitousCare"
                        @change="updateTotal()">
                <label>Gratuitous Care Discount</label>
            </div>
        </control>

        <control label="Total"
                 before-after="pound-on-dark">
            <input autocomplete="off" :value="currencyFormat(period.total, '')" type="text" disabled>
        </control>

        <control>
            <button class="a-button a-button--smaller"
                    @click="deleteThisPeriod()"
                    :class="index===0?'disabled':''"
                    :disabled="index===0">
                Delete Care Period
            </button>
        </control>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex';
    import moment from 'moment';
    import DateInput from 'components/form/control/DateInput.vue'
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import VueSlider from 'vue-slider-component';
    import currencyFormat from 'mixins/currencyFormat';

    /**
     * Component for a Care Period.
     */
    export default {
        name: 'care-period',
        props: {
            period: {
                type: Object,
                default: {}
            },
            index: {
                type: Number,
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapGetters('mini/care', ['periods']),
            periodStartDateRules() {
                return !moment(this.period.periodStart, 'DD/MM/YYYY').isAfter(moment(this.period.periodEnd, 'DD/MM/YYYY'))
            },
            periodEndDateRules() {
                return !moment(this.period.periodEnd, 'DD/MM/YYYY').isBefore(moment(this.period.periodStart, 'DD/MM/YYYY'));
            },
            overlapsAnother() {
                const otherPeriods = this.periods.filter((period, index) => index !== this.index);
                if (!this.period.periodStart || !this.period.periodEnd || otherPeriods.length === 0) {
                    return false;
                }
                let start = moment(this.period.periodStart,'DD/MM/YYYY');
                let end = moment(this.period.periodEnd,'DD/MM/YYYY');
                return otherPeriods.reduce((overlaps, period) => {
                    if (overlaps) {
                        return overlaps;
                    }
                    if (!period.periodStart || !period.periodEnd) {
                        return overlaps;
                    }
                    let currentStart = moment(period.periodStart,'DD/MM/YYYY');
                    let currentEnd = moment(period.periodEnd,'DD/MM/YYYY');
                    return currentStart.isBefore(end) && currentEnd.isAfter(start);
                }, false);
            }
        },
        methods: {
            ...mapActions('mini/care', {
                deletePeriod: 'deletePeriod',
                calculatePeriodTotal: 'calculatePeriodTotal',
                updatePeriod: 'updatePeriod',
            }),
            updateTotal() {
                this.calculatePeriodTotal(this.index);
            },
            deleteThisPeriod() {
                this.deletePeriod(this.index);
            }
        },
        components: {
            DateInput,
            Control,
            ControlError,
            VueSlider
        },
        mixins: [
            currencyFormat
        ],
    }
</script>


// WEBPACK FOOTER //
// CarePeriod.vue?2032e840